import {
    createHttpRequest
} from '@jutro/transport';
import appConfig from 'app-config';
import { logError } from '../../../../applications/account-management/src/components/AppInsightsComponent/AppInsightsComponent';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import JSON5 from "json5";

let restService;
const getRestService = (authHeader) => {
    if (!restService) {
        const authOptions = {
            'Authorization': authHeader.Authorization,
            'Ocp-Apim-Subscription-Key': appConfig.env.CRM_OCP_SUBSCRIPTION_KEY
        };
        const baseUrl = appConfig.env.CRM_BASE_URL;

        restService = createHttpRequest(baseUrl, false);
        restService = restService.build();
        restService.defaultOptions.headers = authOptions;
    }
    return restService;
};

export default class CustomCRMService {
    static enrollUser(auth, url, data) {
        let contactProfile;
        try {
            contactProfile = getRestService(auth).post(url, JSON.stringify(data));
        } catch (error) {
            logError(err, SeverityLevel.Information, 'CustomCRMService.enrollUser', 'APIException in CustomCRMService.enrollUser for' +`${url}`);
            if (error) {
                return undefined;
            }
        }
        return contactProfile;
    }

    static getContactProfile(auth, url, data) {
        let contactProfile;
        try {
            contactProfile = getRestService(auth).get(url, data);
        } catch (error) {
            logError(err, SeverityLevel.Information, 'CustomCRMService.getContactProfile', 'APIException in CustomCRMService.getContactProfile for '+ `${url}`);
            if (error) {
                return undefined;
            }
        }
        return contactProfile;
    }

    static updateAccountPreferences(auth, url, data) {
        let userResp;
        try {
            userResp = getRestService(auth).post(url, JSON.stringify(data));
        } catch (error) {
            logError(err, SeverityLevel.Information, 'CustomCRMService.updateAccountPreferences', 'APIException in CustomCRMService.updateAccountPreferences for '+`${url}`); 
            if (error) {
                return undefined;
            }
        }
        return userResp;
    }

    static updateAccount(auth, url, data) {
        let contactProfile;
        try {
            contactProfile = getRestService(auth).post(url, JSON.stringify(data));
        } catch (error) {
            logError(err, SeverityLevel.Information, 'CustomCRMService.updateAccount', 'APIException in CustomCRMService.updateAccount for '+`${url}`); 
            if (error) {
                return undefined;
            }
        }
        return contactProfile;
    }

    static verifyPolicy(auth, url, data) {
        const verifyPolicy = getRestService(auth).get(url, data);
        return verifyPolicy;
    }

    static verifyUserPolicy(auth, url, data) {
        const verifyPolicyForUser = getRestService(auth).get(url, data);
        return verifyPolicyForUser;
    }

    static addEnrollment(auth, url, addEnrollmentData) {
        try {
            const enrollmentDetails = getRestService(auth).post(url, addEnrollmentData);
            return enrollmentDetails.enrolled;
        } catch (error) {
            logError(err, SeverityLevel.Information, 'CustomCRMService.addEnrollment', 'APIException in CustomCRMService.addEnrollment for '+`${url}`); 
            if (error.response) {
                const {
                    status,
                    data
                } = error.response;
                return undefined;
            }
        }
        return undefined;
    }

    static async getCIAMID(policyNumber) {
        const url = `${appConfig.env.CRM_GET_CIAM_ID_URL}?policyNumber=${policyNumber}`
        const config = {
            method: 'GET',
            headers: {
                'Ocp-Apim-Subscription-Key': appConfig.env.CRM_OCP_SUBSCRIPTION_KEY,
            }
        }        
        try {
            const response = await fetch(url, config);
            const responseText = await response.text();
            let data;
            try {
                data = JSON.parse(responseText);
            } catch {
                data = JSON5.parse(responseText);
            }
            return data;
        } catch (error) {
            return error;
        }
    }

    static async apiRequest(endpoint, method = 'GET', data = null, authHeader, headers = {}, searchParams = {}) {
        const url = new URL(endpoint);
        const config = {
            method,
            headers: {
                'Authorization': authHeader.Authorization,
                'Ocp-Apim-Subscription-Key': appConfig.env.CRM_OCP_SUBSCRIPTION_KEY,
                ... headers,
            }
        }
    
        if(data) {
            config.body = JSON.stringify(data);
        }
    
        if(Object.keys(searchParams).length > 0) {
            url.search = new URLSearchParams(searchParams).toString();
        };
        
        const response = await fetch(url, config).then((res) => {
                        if (!res.ok) {
                            // status NOT in the range 200-299
                            if (res.status === 401) {
                                return Promise.reject({
                                    status: 401
                                });
                            }
                           return res.json();
                        }
                        return res.json();
                    }).then((data) => {
                        return data;
                    }).catch((error) => {
                        return error;
                    });
    
                    return response;
    } 
    
    
}
